<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: Number, default: null },
  error: { type: String, default: null },
  validationRules: { type: Object, required: true },
});

const emit = defineEmits([ 'update:modelValue' ]);

const phoneBoxes = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value === '' ? null : value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label field-label"
      for="phone_boxes"
    >
      <span>{{ trans('addresses.details.form.field.phone_boxes.label') }}</span>
    </label>
    <div class="form-field__input field-input field-input--small input-text">
      <input
        id="phone_boxes"
        v-model.number="phoneBoxes"
        type="number"
        :min="validationRules.min"
        :max="validationRules.max"
        name="phone_boxes"
        :class="{ error: error !== null }"
        placeholder="0"
        @focusout="$emit('focusout')"
      >
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>
